import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { QuicklinkModule } from 'ngx-quicklink';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { SalesQuotationComponent } from './sales-quotation/sales-quotation.component';
import { LoadingOrderComponent } from './loading-order/loading-order.component';
import { EditLoadingOrderComponent } from './loading-order/edit-loading-order/edit-loading-order.component';
import { CreateUpdateSalesQuotationComponent } from './sales-quotation/create-update-sales-quotation/create-update-sales-quotation/create-update-sales-quotation.component';
import { AddLoadingOrderComponent } from './loading-order/add-loading-order/add-loading-order.component';
import { SalesOrderComponent } from './sales-order/sales-order.component';
import { SalesDeliveryComponent } from './sales-delivery/sales-delivery.component';
import { CreateUpdateSalesOrderComponent } from './sales-order/create-update-sales-order/create-update-sales-order.component';
import { CreateUpdateSalesDeliveryComponent } from './sales-delivery/create-update-sales-delivery/create-update-sales-delivery.component';
import { TransactionsComponent } from './transactions.component';
import { ViewLoadingOrderComponent } from './loading-order/view-loading-order/view-loading-order.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';
import { CreateUpdatePurchaseOrderComponent } from './purchase-order/create-update-puchase-order/create-update-purchase-order.component';


const routes: VexRoutes = [
  {
    path: 'sales-quotation',
    component: SalesQuotationComponent,
  },
  {
    path: 'loading-order',
    component: LoadingOrderComponent,
  },
  {
    path: 'loading-order/edit/:id',
    component: EditLoadingOrderComponent,
  },
  {
    path: 'loading-order/view/:id',
    component: ViewLoadingOrderComponent,
  },
  {
    path: 'driver-trips/loading-order/view/:id',
    component: ViewLoadingOrderComponent,
  },
  {
    path: 'add-loading-order/sales-order/:id',
    component: AddLoadingOrderComponent,
  },
  {
    path: 'sales-quotation/create',
    component: CreateUpdateSalesQuotationComponent,
  },
  {
    path: 'sales-quotation/edit/:id',
    component: CreateUpdateSalesQuotationComponent,
  },
  {
    path: 'sales-quotation/copy/:id',
    component: CreateUpdateSalesQuotationComponent,
  },
  {
    path: 'sales-quotation/view/:id',
    component: CreateUpdateSalesQuotationComponent,
  },
  
  {
    path:'sales-orders',
    component:SalesOrderComponent,
  },
  {
    path: 'sales-orders/create',
    component: CreateUpdateSalesOrderComponent,
  },
  {
    path: 'sales-orders/edit/:id',
    component: CreateUpdateSalesOrderComponent,
  },
  {
    path: 'sales-orders/copy/:id',
    component: CreateUpdateSalesOrderComponent,
  },
  {
    path: 'sales-orders/view/:id',
    component: CreateUpdateSalesOrderComponent,
  },
  {
    path:'sales-deliveries',
    component:SalesDeliveryComponent
  },
  {
    path: 'sales-deliveries/create',
    component: CreateUpdateSalesDeliveryComponent,
  },
  {
    path: 'sales-deliveries/edit/:id',
    component: CreateUpdateSalesDeliveryComponent,
  },
  {
    path: 'sales-deliveries/copy/:id',
    component: CreateUpdateSalesDeliveryComponent,
  },
  {
    path: 'sales-deliveries/view/:id',
    component: CreateUpdateSalesDeliveryComponent,
  },
  {
    path:'purchase-orders',
    component:PurchaseOrderComponent,
  },
  {
    path: 'purchase-orders/create',
    component:CreateUpdatePurchaseOrderComponent ,
  },
  {
    path: 'purchase-orders/edit/:id',
    component: CreateUpdatePurchaseOrderComponent,
  },
  {
    path: 'purchase-orders/copy/:id',
    component: CreateUpdatePurchaseOrderComponent,
  },
  {
    path: 'purchase-orders/view/:id',
    component: CreateUpdatePurchaseOrderComponent,
  },
];
@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class TransactionsRoutingModule { }
